(function ($) {
	/* ---------------------------------------
		ハンバーガーメニュー
	--------------------------------------- */
	$('.nav_btn').on('click', function () {
		$(this).toggleClass('active');
		$('body').toggleClass('gnav_open');
	});
	$('.cover,.nav_global_wrap a').on('click', function () {
		if ($('body').hasClass('gnav_open')) {
			$('body').removeClass('gnav_open');
			$('.nav_btn').removeClass('active');
		}
	});

	/* ---------------------------------------
		ページトップ
	--------------------------------------- */
	$(function () {
		var page_top = $('.page_top a');
		page_top.click(function () {
			$('body, html').animate({ scrollTop: 0 }, 500);
			return false;
		});
	});

	/* ---------------------------------------
		object fit ie
	--------------------------------------- */
	objectFitImages('.objectfit img, .img_trim img');

	/* ---------------------------------------
		fancybox
	--------------------------------------- */
	$('[data-fancybox^="gallery"]').fancybox({
		buttons: [
			'close'
		],
	});

	/* ---------------------------------------
		category_list current
	--------------------------------------- */
	$(function () {
		$('.category_list li a').each(function () {
			var $href = new RegExp('^' + $(this).attr('href').replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1") + '$', 'i');
			if (location.href.match($href)) {
				$(this).parent().addClass('current');
			} else {
				$(this).parent().removeClass('current');
			}
		});
	});
	/* ---------------------------------------
		ページ遷移時にフェードイン・アウト
	--------------------------------------- */
	$(window).on('load', function () {
		$('body').removeClass('fadeout');
	});

	/* ---------------------------------------
	end
	--------------------------------------- */
})(jQuery);

/* ---------------------------------------
	coordination_slide
--------------------------------------- */
(function ($) {
	var slide = $('.coordination_slide');
	if (slide.length) {
		slide.slick({
			autoplay: true,
			autoplaySpeed: 5000,
			infinite: true,
			speed: 1500,
			dots: true,
			centerMode: true,
			variableWidth: true,
			appendArrows: $('.slick_arrows'),
			prevArrow: '<div class="slick_prev"></div>',
			nextArrow: '<div class="slick_next"></div>',
		});
	}
})(jQuery);

/* ---------------------------------------
	アコーディオン
--------------------------------------- */
(function ($) {
	var accordionContainer = $('.accordion_container');
	var accordionItem = $('.accordion_item');
	var accordionTitle = $('.accordion_title');
	var accordionContent = $('.accordion_content');
	accordionContent.css("display", "none");
	var w = $(window).width();
	var headH = 0;
	if (w <= 600) {
		var headH = $('.header').outerHeight();
		var headH = headH;
	}
	accordionTitle.click(function () {
		var clicks = $(this).data('clicks');
		$(this).toggleClass('open');
		$(this).next().slideToggle();
		if (clicks) {
		} else {
			var top = $(this).offset().top - headH;
			$('html,body').animate({ scrollTop: top }, 500);
		}
		$(this).data("clicks", !clicks);
	});

	/* ---------------------------------------
		別ページのアコーディオンをオープン
	--------------------------------------- */
	var hash = location.hash;
	var tab = accordionItem;
	if (hash.length) {
		//ハッシュがあったら
		if (hash.match(/#num/)) {
			//番号
			var tabName = Number(hash.slice(4.1) - 1);
			//遅延
			accordionContainer.delay(100).queue(function () {
				//上部タブ部分
				tab.eq(tabName).find(accordionTitle).addClass('open');
				tab.eq(tabName).find(accordionContent).slideDown(800);
				var top = tab.eq(tabName).find(accordionTitle).offset().top - headH;
				$('html,body').animate({ scrollTop: top }, 500);
			}); //queue
		} //if hash
	} //hash.length
})(jQuery);

/* ---------------------------------------
	fancybox
--------------------------------------- */
(function ($) {
	var images = $('.wp-block-image a, .wp-block-gallery a');
	if (images.length) {
		images.attr({
			'data-fancybox': ''
		});
		$("[data-fancybox]").fancybox({
			loop: true,
			buttons: [
				'close',
			],
			animationEffect: 'fade'
		});
	}
})(jQuery);